import {
  FormControl,
  InputLabel,
  MenuItem,
  makeStyles,
  Select,
} from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

export interface SortOption {
  label: string;
  field: string;
  direction?: "ASC" | "DESC";
}

const styles = makeStyles(() => ({
  select: {
    fontWeight: 600,
  },
}));
export const SortBySelect = (props: {
  options: SortOption[];
  value: SortOption;
  onChange: (value: SortOption) => void;
}): JSX.Element => {
  const { options, value, onChange } = props;
  const classes = styles();
  const { formatMessage } = useIntl();

  // Map of the field value to its SortOption obj for efficient lookup
  const optionsMap = React.useMemo(
    () =>
      options.reduce(
        (map, option) => map.set(option.label, option),
        new Map<SortOption["label"], SortOption>(),
      ),
    [options],
  );

  const handleChange = (
    event: React.ChangeEvent<{
      value: SortOption["label"];
    }>,
  ) => onChange(optionsMap.get(event.target.value));

  const label = formatMessage({
    id: "inventory.overview.list.sort.label",
    defaultMessage: "Sort By",
  });

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="sortByLabel">{label}</InputLabel>
      <Select
        labelId="sortByLabel"
        id="sortBySelect"
        value={value?.label ?? ""}
        renderValue={(optionLabel: SortOption["label"]) =>
          optionsMap.get(optionLabel)?.label
        }
        onChange={handleChange}
        label={label}
        classes={classes}
        data-testid="inventoryOverviewSortSelect"
      >
        {options.map((option) => (
          <MenuItem key={option.label} value={option.label}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
